import { Alert, Heading, Paragraph } from "@digdir/designsystemet-react";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useSelskaper } from "../selskap/SelskapContext";
import { useInnstillingerData } from "./innstillingerData";

export const InnstillingerManglerAdvarsler = () => {
  const { active } = useSelskaper();
  const { t } = useTranslation();

  const { innstillinger, isLoading, error } = useInnstillingerData(
    active?.organisasjonsnummer,
  );

  const kontonummerMangler =
    !innstillinger?.norgesprisKontonummer ||
    !innstillinger?.strømstønadKontonummer;
  const epostMangler = !innstillinger?.fakturaEpost;
  if (isLoading || error || (!kontonummerMangler && !epostMangler)) {
    return null;
  }
  return (
    <div className="max-w-page mx-auto mt-8 px-4">
      <Alert data-color="warning" className="w-fit sm:mx-12 mx-2 space-y-3">
        <Heading level={3} data-size="xs">
          {kontonummerMangler &&
            epostMangler &&
            t("pages.innstillinger.mangler.alt")}
        </Heading>
        <Paragraph>
          {t("pages.innstillinger.mangler.varsel", { selskap: active?.navn })}
        </Paragraph>
        <Paragraph>
          <Link to="/innstillinger" className="underline">
            {t("pages.innstillinger.mangler.lenke")}
          </Link>
        </Paragraph>
      </Alert>
    </div>
  );
};
